const cardStyles = {
  borderRadius: "12px",
  backgroundColor: "#fff",
  border: "1px solid #eaeaea",
  boxShadow: "none",
  padding: "24px",
  marginBottom: "24px",
  width: "100%",
};

const inputGridStyles = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "1fr 1fr",
  },
  gap: "24px",
  width: "100%",
};

const saveChangesButtonStyles = {
  fontSize: "15px",
  fontWeight: 500,
  textTransform: "none",
  borderRadius: "8px",
  backgroundColor: "rgba(37, 124, 109, 1)",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "rgba(37, 124, 109, 0.9)",
    boxShadow: "none",
  },
};

const saveButtonWrapperStyles = {
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  mt: "36px",
};

const addPlatformButtonStyles = {
  whiteSpace: "nowrap",
  backgroundColor: "rgba(242, 243, 251, 1)",
  border: "1px solid rgba(242, 243, 251, 1)",
  color: "rgba(37, 124, 109, 1)",
  borderRadius: "8px",
  fontSize: "15px",
  fontWeight: 500,
  width: "128px",
  height: "39px",
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "rgba(242, 243, 251, 0.9)",
  },
  "&.Mui-disabled": { opacity: 0.8 },
};

const bankHeadingWrapper = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: { xs: "flex-start", sm: "center" },
  gap: "8px",
};

const bankHeadingTextBox = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  alignItems: { xs: "flex-start", sm: "center" },
  gap: "8px",
};

const fieldsLabelStyles = {
  fontSize: "15px",
  fontWeight: 500,
};

const fieldsLabelLightStyles = {
  fontSize: "15px",
  fontWeight: 400,
};

const offHoursSurchargeBoxStyles = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: { xs: "flex-start", md: "center" },
  flexWrap: "wrap",
  gap: "2px",
};

const muiStyles = {
  cardStyles,
  inputGridStyles,
  saveChangesButtonStyles,
  saveButtonWrapperStyles,
  addPlatformButtonStyles,
  bankHeadingWrapper,
  bankHeadingTextBox,
  fieldsLabelStyles,
  fieldsLabelLightStyles,
  offHoursSurchargeBoxStyles,
};

export default muiStyles;
